/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "services/api-client";

export const useGetAllRoutes = (data: any) =>
  useQuery<any>({
    queryKey: [
      "GetAllRoutes",
      data?.operationDate,
      data?.customerId,
      data?.pageNumber
    ],
    queryFn: () => client(`maintenance/services/area/routes`, { data })
  });

export const useUpdateRoutesTeam = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`resources/routes/update/field/team`, {
        data,
        successMessage: "Routes teams updated successfully!"
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GetAllRoutes"] });
      }
    }
  });
};
export const useGenerateRoster = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/create/daily/roster`, {
        data,
        successMessage: "Roster created successfully!"
      })
  });

export const useAddRoute = () =>
  useMutation({
    mutationFn: (data: any) => client(`daily/operations/add/routes`, { data })
  });

export const useDeleteRoute = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/delete/routes`, {
        data,
        successMessage: "Selected routes deleted successfully!"
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GetAllRoutes"] });
      }
    }
  });
};

export const useAddNewRoute = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`resources/routes/add`, {
        data,
        successMessage: "Route added successfully!"
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GetAllRoutes"] });
      }
    }
  });
};

export const useEditRoute = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`resources/routes/edit`, {
        data,
        successMessage: "Route updated successfully!"
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GetAllRoutes"] });
      }
    }
  });
};
